import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'FileCompression.AudioFormat',
})
export class FileCompressionAudioFormat {
  @GenericLookup({
    code: 'FileCompression.AudioFormat.Mono',
  })
  static mono: number;

  @GenericLookup({
    code: 'FileCompression.AudioFormat.Stereo',
  })
  static stereo: number;
}
